module.exports = __webpack_public_path__ + "static/media/1x2.be9e132e.svg";